// Logistics Skills organized by subcategories
export const LOGISTICS_SKILLS_CATEGORIES = [
  {
    name: 'Supply Chain Management',
    skills: [
      'Supply Chain Strategy', 'Supply Chain Planning', 'Supply Chain Optimization',
      'Demand Planning', 'Supply Planning', 'Inventory Management',
      'Supplier Management', 'Distribution Network', 'Supply Chain Analytics',
      'Risk Management', 'Cost Optimization', 'Performance Metrics',
      'Supply Chain Technology', 'Network Design', 'Process Improvement'
    ]
  },
  {
    name: 'Warehouse Management',
    skills: [
      'Warehouse Operations', 'Inventory Control', 'Storage Optimization',
      'Order Fulfillment', 'Material Handling', 'Warehouse Safety',
      'Stock Management', 'Quality Control', 'Warehouse Layout',
      'Equipment Management', 'Staff Coordination', 'Process Efficiency',
      'Warehouse Systems', 'Inventory Tracking', 'Performance Monitoring'
    ]
  },
  {
    name: 'Transportation Management',
    skills: [
      'Route Optimization', 'Fleet Management', 'Carrier Relations',
      'Freight Management', 'Transport Planning', 'Cost Analysis',
      'Shipping Documentation', 'Compliance Management', 'Load Planning',
      'Transport Safety', 'Vehicle Maintenance', 'Driver Management',
      'Transport Technology', 'Performance Tracking', 'Route Planning'
    ]
  },
  {
    name: 'Inventory Management',
    skills: [
      'Stock Control', 'Demand Forecasting', 'Inventory Planning',
      'ABC Analysis', 'Cycle Counting', 'Reorder Points',
      'Stock Optimization', 'Inventory Tracking', 'Storage Management',
      'Cost Management', 'Quality Control', 'Inventory Systems',
      'Performance Metrics', 'Process Improvement', 'Risk Management'
    ]
  },
  {
    name: 'Distribution Operations',
    skills: [
      'Distribution Planning', 'Network Optimization', 'Order Processing',
      'Delivery Management', 'Cross-docking', 'Last Mile Delivery',
      'Distribution Centers', 'Customer Service', 'Quality Assurance',
      'Cost Control', 'Performance Tracking', 'Process Efficiency',
      'Distribution Systems', 'Route Optimization', 'Service Level Management'
    ]
  },
  {
    name: 'Procurement and Sourcing',
    skills: [
      'Strategic Sourcing', 'Vendor Management', 'Contract Negotiation',
      'Cost Analysis', 'Supplier Relations', 'Purchase Planning',
      'Quality Management', 'Risk Assessment', 'Market Analysis',
      'Price Negotiation', 'Supplier Selection', 'Performance Monitoring',
      'Procurement Systems', 'Process Improvement', 'Compliance Management'
    ]
  },
  {
    name: 'International Logistics',
    skills: [
      'Global Supply Chain', 'International Shipping', 'Customs Compliance',
      'Import/Export', 'Trade Regulations', 'Documentation Management',
      'Global Transportation', 'International Trade', 'Cross-border Operations',
      'Freight Forwarding', 'Global Distribution', 'Compliance Management',
      'Risk Management', 'Cost Control', 'Performance Tracking'
    ]
  },
  {
    name: 'Logistics Technology',
    skills: [
      'WMS Systems', 'TMS Systems', 'ERP Systems',
      'Inventory Software', 'Analytics Tools', 'Tracking Systems',
      'Automation Technology', 'Mobile Solutions', 'Data Management',
      'System Integration', 'Technology Implementation', 'Process Automation',
      'Performance Analytics', 'Digital Solutions', 'Technology Strategy'
    ]
  },
  {
    name: 'Quality and Compliance',
    skills: [
      'Quality Control', 'Compliance Management', 'Standard Operating Procedures',
      'Audit Management', 'Safety Compliance', 'Risk Management',
      'Documentation Control', 'Performance Standards', 'Quality Assurance',
      'Regulatory Compliance', 'Process Control', 'Inspection Procedures',
      'Quality Systems', 'Compliance Training', 'Quality Improvement'
    ]
  },
  {
    name: 'Project Management',
    skills: [
      'Project Planning', 'Resource Management', 'Timeline Management',
      'Risk Assessment', 'Stakeholder Management', 'Budget Control',
      'Team Coordination', 'Performance Tracking', 'Process Implementation',
      'Change Management', 'Quality Control', 'Project Documentation',
      'Success Metrics', 'Project Strategy', 'Results Delivery'
    ]
  },
  {
    name: 'Customer Service',
    skills: [
      'Order Management', 'Customer Communication', 'Problem Resolution',
      'Service Level Management', 'Complaint Handling', 'Customer Support',
      'Account Management', 'Service Quality', 'Customer Relations',
      'Performance Monitoring', 'Service Improvement', 'Customer Satisfaction',
      'Communication Skills', 'Problem Solving', 'Customer Experience'
    ]
  },
  {
    name: 'Analytics and Reporting',
    skills: [
      'Data Analysis', 'Performance Metrics', 'Report Generation',
      'KPI Management', 'Business Intelligence', 'Cost Analysis',
      'Trend Analysis', 'Forecasting', 'Analytics Tools',
      'Data Visualization', 'Statistical Analysis', 'Decision Support',
      'Performance Reporting', 'Data Management', 'Analytics Strategy'
    ]
  }
];

// Export flattened list for backward compatibility
export const LOGISTICS_SKILLS = LOGISTICS_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
